<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      @changeStatus="changeLeftSideStatus"
      :track_number="filterProp.trackNumber"
      :time_from="filterProp.timeCreatedFrom"
      :time_to="filterProp.timeCreatedTo"
      :package_id="filterProp.packageId"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :track_number="filterProp.trackNumber"
        :time_from="filterProp.timeCreatedFrom"
        :time_to="filterProp.timeCreatedTo"
        :package_id="filterProp.packageId"
        @clearKey="clearKey"
        @openSize="openSize"
      />
      <ul class="tabs">
        <li>
          <router-link to="/sign">{{ $t("transfer.快递签收") }}</router-link>
        </li>
        <li class="shadow">
          <a class="active" href="javascript:;">{{
            $t("transfer.签收记录查询")
          }}</a>
        </li>
        <li>
          <router-link to="/sign-customer">{{
            $t("transfer.代客预报")
          }}</router-link>
        </li>
      </ul>
      <router-view
        :first_loading="firstLoading"
        :items="items"
        @print="print"
      ></router-view>
      <pagination
        v-if="!firstLoading"
        class="pd-x-20 pd-sm-x-30"
        :cur="page"
        :all="totalPage"
        :path="'/sign-check/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      ></pagination>
    </div>
    <api-loading :show="loading"></api-loading>
    <Modal
      :modalId="'modalBarcodeSize'"
      :home="false"
      :size="'sm'"
      :autoH="true"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("transfer.设置打印标签尺寸") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner">
          <div class="form-group row mg-b-0">
            <label
              class="
                col-md-3 col-sm-12 col-form-label
                form-control-sm
                text-right
              "
            >
              {{ $t("transfer.规格(mm):") }}
            </label>
            <div class="col-md-4 col-sm-12">
              <input
                v-model="modalBarcodeSize.width"
                :placeholder="$t('transfer.宽(mm)')"
                type="text"
                class="form-control form-control-sm"
              />
            </div>
            <div class="col-md-4 col-sm-12">
              <input
                v-model="modalBarcodeSize.height"
                :placeholder="$t('transfer.高(mm)')"
                type="text"
                class="form-control form-control-sm"
              />
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="modal-footer d-block pd-y-15 pd-x-0">
          <div
            class="
              form-group
              row
              align-items-center
              justify-content-end
              pd-x-25
              mg-b-0
            "
          >
            <button
              type="button"
              class="
                mg-r-30
                btn btn-primary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              @click="saveBarcodeSize()"
            >
              {{ $t("transfer.保存") }}
            </button>
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
            >
              {{ $t("transfer.取消") }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import LeftSide from "./left-side.vue"; //左边栏
import Header from "./header.vue"; //头
import Modal from "@components/Modal";
import { confirmComponent } from "@components/components.js"; //删除确认
import { pagination } from "@components/pagination.js"; //分页
import { getLodop } from "@/directive/LodopFuncs.js"; //分页

export default {
  components: {
    Header,
    Modal,
    pagination,
    confirmComponent,
    LeftSide,
  },
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      loading: false,
      firstLoading: true,
      items: [],
      page: this.$route.params.page ? this.$route.params.page : 1,
      pageSizeSelect: [10, 20, 50],
      rowsPerPage: parseInt(store.get("sign-check-rowsPerPage"))
        ? parseInt(store.get("sign-check-rowsPerPage"))
        : 10,
      totalPage: 0,
      totalCount: 0,
      filterProp: {
        trackNumber: "",
        timeCreatedFrom: "",
        timeCreatedTo: "",
        packageId: "",
      },
      modalBarcodeSize: {
        width: "",
        height: "",
      },
    };
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("sign-check-rowsPerPage", this.rowsPerPage);
    },
  },
  updated() {
    $('[data-toggle="tooltip-primary"]').tooltip({
      template:
        '<div class="tooltip tooltip-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });
  },
  methods: {
    openSize() {
      $("#modalBarcodeSize").modal("show");
      if (localStorage.getItem("saveBarcodeSizeInfo")) {
        this.modalBarcodeSize.width = JSON.parse(
          localStorage.getItem("saveBarcodeSizeInfo")
        ).width;
        this.modalBarcodeSize.height = JSON.parse(
          localStorage.getItem("saveBarcodeSizeInfo")
        ).height;
      }
    },
    saveBarcodeSize() {
      if (!this.modalBarcodeSize.width || !this.modalBarcodeSize.height) {
        ShowTip(this.$t("transfer.请填写完整的规格"), "danger");
        return;
      }
      $("#modalBarcodeSize").modal("hide");
      localStorage.setItem(
        "saveBarcodeSizeInfo",
        JSON.stringify(this.modalBarcodeSize)
      );
    },
    print(item) {
      let height = 0;
      let LODOP = getLodop(); //调用getLodop获取LODOP对象
      if (!LODOP) return;
      LODOP.PRINT_INIT("");
      if (
        this.modalBarcodeSize.width != "" &&
        this.modalBarcodeSize.height != ""
      ) {
        height = `${this.modalBarcodeSize.height * 3.8 * 0.3}`;
        LODOP.SET_PRINT_PAGESIZE(
          0,
          `${this.modalBarcodeSize.width * 10}`,
          `${this.modalBarcodeSize.height * 10}`,
          ""
        );
        LODOP.ADD_PRINT_BARCODE(
          `${this.modalBarcodeSize.height * 3.8 * 0.05}`,
          `${this.modalBarcodeSize.width * 3.8 * 0.3}`,
          `${this.modalBarcodeSize.width * 3.8 * 0.4}`,
          `${this.modalBarcodeSize.height * 3.8 * 0.4}`,
          "QRCode",
          item.packageId
        );
        LODOP.ADD_PRINT_BARCODE(
          `${this.modalBarcodeSize.height * 3.8 * 0.45}`,
          `${this.modalBarcodeSize.width * 3.8 * 0.1}`,
          `${this.modalBarcodeSize.width * 3.8 * 0.8}`,
          `${this.modalBarcodeSize.height * 3.8 * 0.2}`,
          "Code93",
          item.packageId
        );
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
      } else if (localStorage.getItem("saveBarcodeSizeInfo")) {
        height = `${
          JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).height *
          3.8 *
          0.3
        }`;
        LODOP.SET_PRINT_PAGESIZE(
          0,
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).width * 10
          }`,
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).height * 10
          }`,
          ""
        );
        LODOP.ADD_PRINT_BARCODE(
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).height *
            3.8 *
            0.05
          }`,
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).width *
            3.8 *
            0.3
          }`,
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).width *
            3.8 *
            0.4
          }`,
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).height *
            3.8 *
            0.4
          }`,
          "QRCode",
          item.packageId
        );
        LODOP.ADD_PRINT_BARCODE(
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).height *
            3.8 *
            0.45
          }`,
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).width *
            3.8 *
            0.1
          }`,
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).width *
            3.8 *
            0.8
          }`,
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).height *
            3.8 *
            0.2
          }`,
          "Code93",
          item.packageId
        );
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
      } else {
        height = 100 * 3.8 * 0.3;
        LODOP.SET_PRINT_PAGESIZE(0, "100mm", "50mm", "");
        LODOP.ADD_PRINT_BARCODE(
          100 * 3.8 * 0.05,
          100 * 3.8 * 0.3,
          100 * 3.8 * 0.4,
          100 * 3.8 * 0.4,
          "QRCode",
          item.packageId
        );
        LODOP.ADD_PRINT_BARCODE(
          100 * 3.8 * 0.45,
          100 * 3.8 * 0.1,
          100 * 3.8 * 0.8,
          100 * 3.8 * 0.2,
          "Code93",
          item.packageId
        );
      }
      LODOP.SET_PRINT_STYLEA(0, "ShowBarText", 0); //设置是否显示下方的文字
      if (height < 30) {
        LODOP.ADD_PRINT_TEXT(
          "62%",
          "0%",
          "100%",
          18,
          `内部ID：${item.packageId}`
        );
        LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
      } else if (height < 60) {
        LODOP.ADD_PRINT_TEXT(
          "68%",
          "0%",
          "100%",
          22,
          `内部ID：${item.packageId}`
        );
        LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        LODOP.ADD_PRINT_TEXT(
          "78%",
          "0%",
          "100%",
          22,
          `物流单号：${item.trackNumber}`
        );
        LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        if (item.distributorName != "") {
          LODOP.ADD_PRINT_TEXT(
            "88%",
            "0%",
            "100%",
            18,
            `客户名称：${item.distributorName}`
          );
          LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
          LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        }
      } else if (height < 100) {
        LODOP.ADD_PRINT_TEXT(
          "70%",
          "0%",
          "100%",
          25,
          `内部ID：${item.packageId}`
        );
        LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        LODOP.ADD_PRINT_TEXT(
          "78%",
          "0%",
          "100%",
          25,
          `物流单号：${item.trackNumber}`
        );
        LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        if (item.distributorName != "") {
          LODOP.ADD_PRINT_TEXT(
            "86%",
            "0%",
            "100%",
            18,
            `客户名称：${item.distributorName}`
          );
          LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
          LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        }
      } else {
        LODOP.ADD_PRINT_TEXT(
          "70%",
          "0%",
          "100%",
          30,
          `内部ID：${item.packageId}`
        );
        LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        LODOP.ADD_PRINT_TEXT(
          "78%",
          "0%",
          "100%",
          30,
          `物流单号：${item.trackNumber}`
        );
        LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        if (item.distributorName != "") {
          LODOP.ADD_PRINT_TEXT(
            "86%",
            "0%",
            "100%",
            18,
            `客户名称：${item.distributorName}`
          );
          LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
          LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        }
      }
      LODOP.PRINT();
    },
    clearKey(type) {
      this.filterProp[type] = "";
      if (type == "time") {
        this.filterProp.timeCreatedFrom = this.filterProp.timeCreatedTo = "";
      }
      this.toPage(1);
    },
    filtrate(trackNumber, timeCreatedFrom, timeCreatedTo, packageId) {
      this.filterProp.trackNumber = trackNumber;
      this.filterProp.timeCreatedFrom = timeCreatedFrom;
      this.filterProp.timeCreatedTo = timeCreatedTo;
      this.filterProp.packageId = packageId;
      this.toPage(1);
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getList();
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.replace({ path: "/sign-check/" + 1 });
      if (page == 1) {
        this.getList();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.replace({ path: "/sign-check/" + num });
      if (page == num) {
        this.getList();
      }
    },
    changeLeftSideStatus() {
      //改变左边栏状态
      this.leftSideStatus = !this.leftSideStatus;
      store.set("leftSideStatus", this.leftSideStatus);
    },
    getList(s) {
      this.loading = true;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        trackNumber: this.filterProp.trackNumber,
        timeCreatedFrom: this.filterProp.timeCreatedFrom,
        timeCreatedTo: this.filterProp.timeCreatedTo,
        packageId: this.filterProp.packageId,
      };
      $.api_call("api.DistributorPackage.findsPackageRecord", params, (r) => {
        this.loading = false;
        this.firstLoading = false;
        if (r.ErrorCode == "9999") {
          this.items = r.Data.Results;
          this.totalPage = r.Data.Pagination.totalPage;
          this.totalCount = r.Data.Pagination.totalCount;
          if (!s) $("html,body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
  },
  mounted() {
    if (
      this.modalBarcodeSize.width != "" &&
      this.modalBarcodeSize.width != ""
    ) {
    } else if (localStorage.getItem("saveBarcodeSizeInfo")) {
    } else {
      $("#modalBarcodeSize").modal("show");
    }
    this.getList();
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          '<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">this.$t("transfer.更多")</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>'
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("transfer.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("transfer.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
        });
      }
    }
  },
};
</script>

<style lang="less" scoped>
.nav.nav-tabs {
  .nav-item {
    background-color: #fff;
    .nav-link {
      border-bottom-color: #ddd;
    }
    .nav-link:active,
    .nav-link.active {
      border-bottom: 1px solid transparent;
      color: inherit;
      background-color: #fff;
    }
    .nav-link:focus {
      color: #868ba1;
    }
    .nav-link:hover {
      background-color: #f0f0f0;
      color: #868ba1;
    }
    .nav-link.active:hover {
      background-color: #fff;
    }
  }
}
.tab-content {
  border: 1px #ddd solid;
  border-top: none;
  padding: 0 15px;
  .tab-container.active {
    display: block;
  }
  .tab-container {
    display: none;
  }
}

.modal-content {
  .sku-list {
    h3 {
      margin-bottom: 5px;
      height: 26px;
      line-height: 26px;
      font-size: 14px;
    }
  }
  tbody {
    font-size: 12px;
  }
  .pro-info {
    display: flex;
    .img-wrap {
      margin-right: 5px;
      max-width: 60px;
      max-height: 60px;
      min-width: 60px;
      min-height: 60px;
      border: 1px #ddd solid;
      background-color: #fff;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
    .right {
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      max-width: 200px;
      min-width: 200px;
      line-height: 20px;
      .pro-attr {
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .table-wrap {
    margin-bottom: 15px;
  }
  .new-return-bottom {
    border-top: 1px #ddd solid;
    padding: 15px 15px 0;
  }
  textarea {
    resize: none;
  }
}
.info-wrap {
  padding-top: 15px;
  border-top: 1px solid #ddd;
}
.input-wrap {
  margin: 0 -15px;
  padding-top: 15px;
  border-top: 1px solid #ddd;
}
</style>

